// Turbo, replacing the vendored turbolinks-classic fork. Parity with the fork is the goal — read
// docs/turbo_migration.md before changing any of this. Importing auto-starts Turbo.

import { cache, session } from "@hotwired/turbo"

// The fork had no form handling, so jquery_ujs keeps every form and .js.erb response. Turbo only
// converts links carrying data-turbo-method, never jquery_ujs's data-method.
session.formMode = "off"

// The fork's ProgressBar delay; Turbo defaults to 500.
session.progressBarDelay = 400

// "no-preview", not exemptPageFromCache()'s "no-cache": the fork rendered no stale preview but did
// keep a page cache for back/forward restoration.
document.addEventListener("turbo:load", () => cache.exemptPageFromPreview())

// The three rules from the fork's Link#shouldIgnore that Turbo does not enforce itself. Cancelling
// turbo:click makes Turbo stand down without preventing the click, so the browser follows the link.
// The fork's fourth rule, _optOut, is gone: data-no-turbolink was renamed to data-turbo="false"
// across the ~109 sites, which Turbo's own elementIsNavigatable honours on the link or an ancestor.
const HTML_EXTENSION = /^\.html?$/i
const ANY_EXTENSION = /\.[a-z0-9]+$/i

const exemptUnderClassicRules = (link) => {
  // _target: Turbo allows target="_self", the fork allowed none
  if (link.getAttribute("target")) return true

  // _anchored: href="#" JS hooks and same-path anchors, which Turbo 8 would re-fetch
  const isAnchored = link.hash.length > 0 || link.href.endsWith("#")
  if (isAnchored && link.pathname === window.location.pathname && link.search === window.location.search) return true

  // _nonHtml: .xlsx/.pdf/.csv links; the fork allowed only .html, Turbo's denylist is looser
  const extension = link.pathname.match(ANY_EXTENSION)
  if (extension && !HTML_EXTENSION.test(extension[0])) return true

  return false
}

document.addEventListener("turbo:click", (event) => {
  if (exemptUnderClassicRules(event.target)) event.preventDefault()
})

// The kill switch for programmatic visits: the fork degraded Turbolinks.visit to a full load on
// non-GET-rendered pages, where data-turbo="false" only stops link interception. Restoration
// visits do not fire this event.
document.addEventListener("turbo:before-visit", (event) => {
  if (document.body && document.body.getAttribute("data-turbo") === "false") {
    event.preventDefault()
    window.location.href = event.detail.url
  }
})
